import logoWhite from "../assets/logowhite.png";

const navItems = [
  { key: "home", href: "/", label: "Home" },
  { key: "about", href: "/about", label: "About" },
  { key: "apps", href: "/apps", label: "Apps" },
];

function Navbar({ activePage }) {
  return (
    <nav className="navbar">
      <div className="brand-wrap">
        <img className="brand-logo" src={logoWhite} alt="Vortax logo" />
        <div className="brand">Vortax</div>
      </div>
      <div className="nav-links" aria-label="Main navigation">
        {navItems.map((item) => {
          const className =
            activePage === item.key ? "nav-link active" : "nav-link";
          return (
            <a key={item.key} className={className} href={item.href}>
              {item.label}
            </a>
          );
        })}
      </div>
    </nav>
  );
}

export default Navbar;
